import * as THREE from 'three';
import { createCanvas } from '../core/canvas-texture.js';

const textureLoader = new THREE.TextureLoader();
const textureCache = new Map();

/**
 * Tải và lưu cache texture
 */
export function loadCachedTexture(url, isPixel = false) {
  if (textureCache.has(url)) {
    return Promise.resolve(textureCache.get(url));
  }
  return new Promise((resolve) => {
    textureLoader.load(
      url,
      (tex) => {
        tex.colorSpace = THREE.SRGBColorSpace;
        if (isPixel) {
          tex.magFilter = THREE.NearestFilter;
          tex.minFilter = THREE.NearestFilter;
        } else {
          tex.magFilter = THREE.LinearFilter;
          tex.minFilter = THREE.LinearMipmapLinearFilter;
        }
        textureCache.set(url, tex);
        resolve(tex);
      },
      undefined,
      (err) => {
        console.warn(`Lỗi tải texture [${url}]:`, err);
        const fallbackCanvas = createCanvas(128, 128);
        const ctx = fallbackCanvas.getContext('2d');
        ctx.fillStyle = '#475569';
        ctx.fillRect(0, 0, 128, 128);
        const fallbackTex = new THREE.CanvasTexture(fallbackCanvas);
        fallbackTex.colorSpace = THREE.SRGBColorSpace;
        resolve(fallbackTex);
      }
    );
  });
}

/**
 * Tạo texture dải bóng tiếp xúc chân tường mềm mại
 */
export function createContactShadowTexture() {
  const cvs = createCanvas(256, 64);
  const ctx = cvs.getContext('2d');

  const grad = ctx.createLinearGradient(0, 0, 0, 64);
  grad.addColorStop(0, 'rgba(0, 0, 0, 0.85)');
  grad.addColorStop(0.35, 'rgba(0, 0, 0, 0.55)');
  grad.addColorStop(0.7, 'rgba(0, 0, 0, 0.2)');
  grad.addColorStop(1, 'rgba(0, 0, 0, 0.0)');

  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, 256, 64);

  const tex = new THREE.CanvasTexture(cvs);
  tex.wrapS = THREE.ClampToEdgeWrapping;
  tex.wrapT = THREE.ClampToEdgeWrapping;
  return tex;
}

/**
 * Tạo Procedural Asphalt Texture (Nhựa đường đô thị nhám đá mịn)
 */
export function createAsphaltTexture() {
  const cvs = createCanvas(512, 512);
  const ctx = cvs.getContext('2d');

  ctx.fillStyle = '#1e2530';
  ctx.fillRect(0, 0, 512, 512);

  for (let i = 0; i < 3000; i++) {
    const x = Math.random() * 512;
    const y = Math.random() * 512;
    const r = Math.random() * 1.5 + 0.5;
    ctx.fillStyle = Math.random() > 0.5 ? '#334155' : '#0f172a';
    ctx.beginPath();
    ctx.arc(x, y, r, 0, Math.PI * 2);
    ctx.fill();
  }

  const tex = new THREE.CanvasTexture(cvs);
  tex.colorSpace = THREE.SRGBColorSpace;
  tex.wrapS = THREE.RepeatWrapping;
  tex.wrapT = THREE.RepeatWrapping;
  tex.repeat.set(12, 6);
  return tex;
}
